import {
  BENEFICIAL_OWNER_CITY,
  BENEFICIAL_OWNER_COUNTRY,
  BENEFICIAL_OWNER_DATE_OF_BIRTH,
  BENEFICIAL_OWNER_FIRST_NAME,
  BENEFICIAL_OWNER_MIDDLE_NAME,
  BENEFICIAL_OWNER_LAST_NAME,
  BENEFICIAL_OWNER_NATIONALITY,
  BENEFICIAL_OWNER_ADDITIONAL_NATIONALITIES,
  BENEFICIAL_OWNER_COUNTRY_OF_BIRTH,
  BENEFICIAL_OWNER_POLITICALLY_EXPOSED,
  BENEFICIAL_OWNER_POLITICALLY_EXPOSED_PASSPORT_DOCUMENT,
  BENEFICIAL_OWNER_POLITICALLY_EXPOSED_PERSON_UTILITY_BILL_DOCUMENT,
  BENEFICIAL_OWNER_POLITICALLY_EXPOSED_REASON,
  BENEFICIAL_OWNER_SALUTATION,
  BENEFICIAL_OWNER_STATE,
  BENEFICIAL_OWNER_STREET_NAME,
  BENEFICIAL_OWNER_STREET_NUMBER,
  BENEFICIAL_OWNER_UBO_OTHER_REASON,
  BENEFICIAL_OWNER_VOTING_SHARE,
  BENEFICIAL_OWNER_ZIP_CODE,
  COMPANY_ANNUAL_TRADE_FILE,
  COMPANY_ARTICLES_OF_ASSOCIATION,
  COMPANY_BANK_STATEMENTS,
  COMPANY_BOARD_RESOLUTION,
  COMPANY_BUSINESS_LICENSE,
  COMPANY_CERTIFICATE_OF_INCORPORATION,
  COMPANY_CERTIFICATE_OF_REGISTRATION,
  COMPANY_CHAMBER_OF_COMMERCE_CERTIFICATE,
  COMPANY_COMPANY_BWA_0,
  COMPANY_COMPANY_BWA_1,
  COMPANY_FINANCIAL_DOCUMENTS,
  COMPANY_INTERIM_FINANCIAL_DOCUMENT,
  COMPANY_CREDIT_FACILITIES,
  COMPANY_DIRECT_DEBIT_BANK_DETAILS,
  COMPANY_DIRECTOR_LIST,
  COMPANY_EXTENDED_DUE_DILIGENCE,
  COMPANY_GROUP_BWA_0,
  COMPANY_GROUP_BWA_1,
  GROUP_COMPANY_FINANCIAL_DOCUMENT,
  GROUP_COMPANY_INTERIM_FINANCIALS,
  COMPANY_IMPORT_EXPORT_CODE,
  COMPANY_LEGAL_REPRESENTATIVES,
  COMPANY_DIRECTORS,
  COMPANY_MEMORANDUM_OF_ASSOCIATION,
  COMPANY_ORGANIZATIONAL_CHART,
  COMPANY_PAN_CARD,
  COMPANY_PARTNERSHIP_DEED,
  COMPANY_REGISTRATION_ISSUER,
  COMPANY_REGISTRATION_NUMBER,
  COMPANY_SELLER_BANK_ACCOUNT,
  COMPANY_SHARE_HOLDER_LIST,
  COMPANY_SUSA,
  COMPANY_TAX_NUMBER,
  COMPANY_TAX_NUMBER_CERTIFICATE,
  COMPANY_TRADE_PARTNERS,
  COMPANY_TRADE_REGISTER_EXTRACT,
  COMPANY_ULTIMATE_BENEFICIAL_OWNERS,
  COMPANY_UTILITY_BILL,
  COMPANY_VAT_NUMBER,
  COMPANY_CIN_CODE,
  DIRECT_DEBIT_ACCOUNT_ACCOUNT_HOLDER,
  DIRECT_DEBIT_ACCOUNT_ACCOUNT_NUMBER,
  DIRECT_DEBIT_ACCOUNT_BANK_CODE,
  DIRECT_DEBIT_ACCOUNT_BANK_NAME,
  DIRECT_DEBIT_ACCOUNT_CITY,
  DIRECT_DEBIT_ACCOUNT_COUNTRY_CODE,
  DIRECT_DEBIT_ACCOUNT_STATE,
  DIRECT_DEBIT_ACCOUNT_STREET_NAME,
  DIRECT_DEBIT_ACCOUNT_STREET_NUMBER,
  DIRECT_DEBIT_ACCOUNT_ZIP_CODE,
  LEGAL_REPRESENTATIVE_AADHAAR_NUMBER,
  LEGAL_REPRESENTATIVE_CITY,
  LEGAL_REPRESENTATIVE_COUNTRY,
  LEGAL_REPRESENTATIVE_DATE_OF_BIRTH,
  LEGAL_REPRESENTATIVE_DIRECTOR_IDENTIFICATION_NUMBER,
  LEGAL_REPRESENTATIVE_EMAIL_ADDRESS,
  LEGAL_REPRESENTATIVE_FIRST_NAME,
  LEGAL_REPRESENTATIVE_MIDDLE_NAME,
  LEGAL_REPRESENTATIVE_IS_SIGNATORY,
  LEGAL_REPRESENTATIVE_LAST_NAME,
  LEGAL_REPRESENTATIVE_NATIONALITY,
  LEGAL_REPRESENTATIVE_ADDITIONAL_NATIONALITIES,
  LEGAL_REPRESENTATIVE_COUNTRY_OF_BIRTH,
  LEGAL_REPRESENTATIVE_POLITICALLY_EXPOSED,
  LEGAL_REPRESENTATIVE_POLITICALLY_EXPOSED_REASON,
  LEGAL_REPRESENTATIVE_POSITION,
  LEGAL_REPRESENTATIVE_SALUTATION,
  LEGAL_REPRESENTATIVE_STATE,
  LEGAL_REPRESENTATIVE_STREET_NAME,
  LEGAL_REPRESENTATIVE_STREET_NUMBER,
  LEGAL_REPRESENTATIVE_TYPE_OF_REPRESENTATION,
  LEGAL_REPRESENTATIVE_ZIP_CODE,
  DIRECTOR_CITY,
  DIRECTOR_COUNTRY,
  DIRECTOR_DATE_OF_BIRTH,
  DIRECTOR_DIRECTOR_IDENTIFICATION_NUMBER,
  DIRECTOR_EMAIL_ADDRESS,
  DIRECTOR_FIRST_NAME,
  DIRECTOR_MIDDLE_NAME,
  DIRECTOR_LAST_NAME,
  DIRECTOR_NATIONALITY,
  DIRECTOR_ADDITIONAL_NATIONALITIES,
  DIRECTOR_COUNTRY_OF_BIRTH,
  DIRECTOR_POLITICALLY_EXPOSED,
  DIRECTOR_POLITICALLY_EXPOSED_REASON,
  DIRECTOR_POSITION,
  DIRECTOR_SALUTATION,
  DIRECTOR_STATE,
  DIRECTOR_STREET_NAME,
  DIRECTOR_STREET_NUMBER,
  DIRECTOR_ZIP_CODE,
  SELLER_BANK_ACCOUNT_ACCOUNT_HOLDER,
  SELLER_BANK_ACCOUNT_ACCOUNT_NUMBER,
  SELLER_BANK_ACCOUNT_BANK_CODE,
  SELLER_BANK_ACCOUNT_CURRENCIES,
  SELLER_BANK_ACCOUNT_TRANSFER_TYPE,
  TRADE_PARTNER_AIRWAY_BILL_DOCUMENT,
  TRADE_PARTNER_AVERAGE_INVOICE_AMOUNT,
  TRADE_PARTNER_BILL_OF_LADING_DOCUMENT,
  TRADE_PARTNER_CRM_CIM_DOCUMENT,
  TRADE_PARTNER_DOCUMENTS_ROUTED_THROUGH_BANK,
  TRADE_PARTNER_EBRC_DOCUMENT,
  TRADE_PARTNER_EXPECTED_EXPORT_VOLUME,
  TRADE_PARTNER_HAS_DELAY_IN_PAYMENTS,
  TRADE_PARTNER_HAS_TRADE_HISTORY,
  TRADE_PARTNER_INVOICE_DOCUMENT,
  TRADE_PARTNER_MAXIMUM_DELAY_IN_DAYS,
  TRADE_PARTNER_MAXIMUM_PAYMENT_TERM,
  TRADE_PARTNER_OUTSTANDING_BALANCE,
  TRADE_PARTNER_PAYMENT_REFERENCE_TYPE,
  TRADE_PARTNER_PURCHASE_ORDER_DOCUMENT,
  TRADE_PARTNER_SUPPORTING_DOCUMENT,
  TRADE_PARTNER_TOTAL_EXPORT_VOLUME,
  TRADE_PARTNER_TRADING_CURRENCY,
  TRADE_PARTNER_TRADING_SINCE,
  TRADE_PARTNER_SAMPLE_DOC_STATEMENT_OF_ACCOUNTS,
  TRADE_PARTNER_SAMPLE_DOC_AGING_REPORT,
  INTERMEDIARY_SHAREHOLDER_CITY,
  INTERMEDIARY_SHAREHOLDER_COMPANY_NAME,
  INTERMEDIARY_SHAREHOLDER_COUNTRY,
  INTERMEDIARY_SHAREHOLDER_STATE,
  INTERMEDIARY_SHAREHOLDER_STREET_NAME,
  INTERMEDIARY_SHAREHOLDER_STREET_NUMBER,
  INTERMEDIARY_SHAREHOLDER_VOTING_SHARE,
  INTERMEDIARY_SHAREHOLDER_ZIP_CODE,
  COMPANY_INTERMEDIARY_SHAREHOLDERS,
} from '@modifi/plugin-onboarding'
import {
  SECTION_ANNUAL_RETURN_FILE,
  SECTION_ASSOCIATION_DOCUMENTS,
  SECTION_BANK_DETAILS,
  SECTION_BOARD_RESOLUTION,
  SECTION_BUSINESS_LICENSE,
  SECTION_BWA_COMPANY_DOCUMENTS,
  SECTION_BWA_GROUP_DOCUMENTS,
  SECTION_CERTIFICATE_OF_INCORPORATION,
  SECTION_CERTIFICATE_OF_REGISTRATION,
  SECTION_CHAMBER_OF_COMMERCE_CERTIFICATE,
  SECTION_COMPANY_PAN_CARD,
  SECTION_COMPANY_UTILITY_BILL,
  SECTION_CREDIT_FACILITIES,
  SECTION_DIRECT_DEBIT_ACCOUNT_DETAILS,
  SECTION_DIRECTOR_LIST,
  SECTION_EXTENDED_DUE_DILIGENCE,
  SECTION_LEGAL_REPRESENTATIVES,
  SECTION_ORGANIZATIONAL_CHART,
  SECTION_PARTNERSHIP_DEED,
  SECTION_REGISTRATION_NUMBERS,
  SECTION_SHARE_HOLDER_LIST,
  SECTION_SUSA,
  SECTION_TAX_NUMBER_CERTIFICATE,
  SECTION_SELLER_TRADE_PARTNERS,
  SECTION_TRADE_REGISTER_EXTRACT,
  SECTION_ULTIMATE_BENEFICIAL_OWNERS,
  SECTION_YEARLY_CLOSING_COMPANY,
  SECTION_YEARLY_CLOSING_GROUP,
  SECTION_COMPANY_DOCUMENTS_LIST,
  SECTION_INTERMEDIARY_SHAREHOLDERS,
  SECTION_DIRECTORS,
  SECTION_OVERVIEW,
  SECTION_OTHER_DOCUMENTS,
} from './sections'

// @Todo move to onboarding package once its safe to merge
const BENEFICIAL_OWNER_VISA_DOCUMENT = 'ultimateBeneficialOwner.visaDocument'

export const STATIC_SECTIONS: string[] = [SECTION_OVERVIEW]

export const DOCUMENTS_SUB_CATEGORIES_TO_INPUT_FIELDS = {
  [SECTION_ORGANIZATIONAL_CHART]: [COMPANY_ORGANIZATIONAL_CHART],
  [SECTION_SHARE_HOLDER_LIST]: [COMPANY_SHARE_HOLDER_LIST],
  [SECTION_TAX_NUMBER_CERTIFICATE]: [COMPANY_TAX_NUMBER_CERTIFICATE],
  [SECTION_BOARD_RESOLUTION]: [COMPANY_BOARD_RESOLUTION],
  [SECTION_DIRECTOR_LIST]: [COMPANY_DIRECTOR_LIST],
  [SECTION_CHAMBER_OF_COMMERCE_CERTIFICATE]: [COMPANY_CHAMBER_OF_COMMERCE_CERTIFICATE],
  [SECTION_EXTENDED_DUE_DILIGENCE]: [COMPANY_EXTENDED_DUE_DILIGENCE],
  [SECTION_CERTIFICATE_OF_INCORPORATION]: [COMPANY_CERTIFICATE_OF_INCORPORATION],
  [SECTION_CERTIFICATE_OF_REGISTRATION]: [COMPANY_CERTIFICATE_OF_REGISTRATION],
  [SECTION_ASSOCIATION_DOCUMENTS]: [
    COMPANY_MEMORANDUM_OF_ASSOCIATION,
    COMPANY_ARTICLES_OF_ASSOCIATION,
  ],
  [SECTION_COMPANY_PAN_CARD]: [COMPANY_PAN_CARD],
  [SECTION_COMPANY_UTILITY_BILL]: [COMPANY_UTILITY_BILL],
  [SECTION_PARTNERSHIP_DEED]: [COMPANY_PARTNERSHIP_DEED],
  [SECTION_BUSINESS_LICENSE]: [COMPANY_BUSINESS_LICENSE],
  [SECTION_TRADE_REGISTER_EXTRACT]: [COMPANY_TRADE_REGISTER_EXTRACT],
  [SECTION_ANNUAL_RETURN_FILE]: [COMPANY_ANNUAL_TRADE_FILE],
  // COMPANY FINANCIALS
  [SECTION_BWA_GROUP_DOCUMENTS]: [COMPANY_GROUP_BWA_1, COMPANY_GROUP_BWA_0],
  [SECTION_BWA_COMPANY_DOCUMENTS]: [COMPANY_COMPANY_BWA_1, COMPANY_COMPANY_BWA_0],
  [SECTION_CREDIT_FACILITIES]: [COMPANY_CREDIT_FACILITIES],
  [SECTION_SUSA]: [COMPANY_SUSA],
  [SECTION_YEARLY_CLOSING_GROUP]: [
    GROUP_COMPANY_FINANCIAL_DOCUMENT,
    GROUP_COMPANY_INTERIM_FINANCIALS,
  ],
  [SECTION_YEARLY_CLOSING_COMPANY]: [
    COMPANY_FINANCIAL_DOCUMENTS,
    COMPANY_INTERIM_FINANCIAL_DOCUMENT,
  ],
}

export const SECTION_TO_INPUT_FIELDS: Record<string, string[]> = {
  [SECTION_SELLER_TRADE_PARTNERS]: [
    COMPANY_TRADE_PARTNERS,
    TRADE_PARTNER_HAS_TRADE_HISTORY,
    TRADE_PARTNER_TRADING_SINCE,
    TRADE_PARTNER_TRADING_CURRENCY,
    TRADE_PARTNER_TOTAL_EXPORT_VOLUME,
    TRADE_PARTNER_OUTSTANDING_BALANCE,
    TRADE_PARTNER_EXPECTED_EXPORT_VOLUME,
    TRADE_PARTNER_AVERAGE_INVOICE_AMOUNT,
    TRADE_PARTNER_MAXIMUM_PAYMENT_TERM,
    TRADE_PARTNER_PAYMENT_REFERENCE_TYPE,
    TRADE_PARTNER_HAS_DELAY_IN_PAYMENTS,
    TRADE_PARTNER_MAXIMUM_DELAY_IN_DAYS,
    TRADE_PARTNER_DOCUMENTS_ROUTED_THROUGH_BANK,
    TRADE_PARTNER_INVOICE_DOCUMENT,
    TRADE_PARTNER_PURCHASE_ORDER_DOCUMENT,
    TRADE_PARTNER_BILL_OF_LADING_DOCUMENT,
    TRADE_PARTNER_AIRWAY_BILL_DOCUMENT,
    TRADE_PARTNER_CRM_CIM_DOCUMENT,
    TRADE_PARTNER_EBRC_DOCUMENT,
    TRADE_PARTNER_SUPPORTING_DOCUMENT,
    TRADE_PARTNER_SAMPLE_DOC_STATEMENT_OF_ACCOUNTS,
    TRADE_PARTNER_SAMPLE_DOC_AGING_REPORT,
  ],
  [SECTION_REGISTRATION_NUMBERS]: [
    COMPANY_VAT_NUMBER,
    COMPANY_TAX_NUMBER,
    COMPANY_REGISTRATION_NUMBER,
    COMPANY_REGISTRATION_ISSUER,
    COMPANY_IMPORT_EXPORT_CODE,
    COMPANY_CIN_CODE,
  ],
  [SECTION_LEGAL_REPRESENTATIVES]: [
    COMPANY_LEGAL_REPRESENTATIVES,
    LEGAL_REPRESENTATIVE_IS_SIGNATORY,
    LEGAL_REPRESENTATIVE_AADHAAR_NUMBER,
    LEGAL_REPRESENTATIVE_CITY,
    LEGAL_REPRESENTATIVE_COUNTRY,
    LEGAL_REPRESENTATIVE_DATE_OF_BIRTH,
    LEGAL_REPRESENTATIVE_DIRECTOR_IDENTIFICATION_NUMBER,
    LEGAL_REPRESENTATIVE_EMAIL_ADDRESS,
    LEGAL_REPRESENTATIVE_FIRST_NAME,
    LEGAL_REPRESENTATIVE_MIDDLE_NAME,
    LEGAL_REPRESENTATIVE_LAST_NAME,
    LEGAL_REPRESENTATIVE_NATIONALITY,
    LEGAL_REPRESENTATIVE_ADDITIONAL_NATIONALITIES,
    LEGAL_REPRESENTATIVE_COUNTRY_OF_BIRTH,
    LEGAL_REPRESENTATIVE_POLITICALLY_EXPOSED,
    LEGAL_REPRESENTATIVE_POLITICALLY_EXPOSED_REASON,
    LEGAL_REPRESENTATIVE_POSITION,
    LEGAL_REPRESENTATIVE_SALUTATION,
    LEGAL_REPRESENTATIVE_STATE,
    LEGAL_REPRESENTATIVE_STREET_NAME,
    LEGAL_REPRESENTATIVE_STREET_NUMBER,
    LEGAL_REPRESENTATIVE_TYPE_OF_REPRESENTATION,
    LEGAL_REPRESENTATIVE_ZIP_CODE,
  ],
  [SECTION_DIRECTORS]: [
    COMPANY_DIRECTORS,
    DIRECTOR_CITY,
    DIRECTOR_COUNTRY,
    DIRECTOR_DATE_OF_BIRTH,
    DIRECTOR_DIRECTOR_IDENTIFICATION_NUMBER,
    DIRECTOR_EMAIL_ADDRESS,
    DIRECTOR_FIRST_NAME,
    DIRECTOR_MIDDLE_NAME,
    DIRECTOR_LAST_NAME,
    DIRECTOR_NATIONALITY,
    DIRECTOR_ADDITIONAL_NATIONALITIES,
    DIRECTOR_COUNTRY_OF_BIRTH,
    DIRECTOR_POLITICALLY_EXPOSED,
    DIRECTOR_POLITICALLY_EXPOSED_REASON,
    DIRECTOR_POSITION,
    DIRECTOR_SALUTATION,
    DIRECTOR_STATE,
    DIRECTOR_STREET_NAME,
    DIRECTOR_STREET_NUMBER,
    DIRECTOR_ZIP_CODE,
  ],
  [SECTION_ULTIMATE_BENEFICIAL_OWNERS]: [
    COMPANY_ULTIMATE_BENEFICIAL_OWNERS,
    BENEFICIAL_OWNER_CITY,
    BENEFICIAL_OWNER_COUNTRY,
    BENEFICIAL_OWNER_DATE_OF_BIRTH,
    BENEFICIAL_OWNER_FIRST_NAME,
    BENEFICIAL_OWNER_MIDDLE_NAME,
    BENEFICIAL_OWNER_LAST_NAME,
    BENEFICIAL_OWNER_NATIONALITY,
    BENEFICIAL_OWNER_ADDITIONAL_NATIONALITIES,
    BENEFICIAL_OWNER_COUNTRY_OF_BIRTH,
    BENEFICIAL_OWNER_POLITICALLY_EXPOSED,
    BENEFICIAL_OWNER_POLITICALLY_EXPOSED_PASSPORT_DOCUMENT,
    BENEFICIAL_OWNER_POLITICALLY_EXPOSED_PERSON_UTILITY_BILL_DOCUMENT,
    BENEFICIAL_OWNER_VISA_DOCUMENT,
    BENEFICIAL_OWNER_POLITICALLY_EXPOSED_REASON,
    BENEFICIAL_OWNER_SALUTATION,
    BENEFICIAL_OWNER_STATE,
    BENEFICIAL_OWNER_STREET_NAME,
    BENEFICIAL_OWNER_STREET_NUMBER,
    BENEFICIAL_OWNER_UBO_OTHER_REASON,
    BENEFICIAL_OWNER_VOTING_SHARE,
    BENEFICIAL_OWNER_ZIP_CODE,
  ],
  [SECTION_INTERMEDIARY_SHAREHOLDERS]: [
    COMPANY_INTERMEDIARY_SHAREHOLDERS,
    INTERMEDIARY_SHAREHOLDER_CITY,
    INTERMEDIARY_SHAREHOLDER_COMPANY_NAME,
    INTERMEDIARY_SHAREHOLDER_COUNTRY,
    INTERMEDIARY_SHAREHOLDER_STATE,
    INTERMEDIARY_SHAREHOLDER_STREET_NAME,
    INTERMEDIARY_SHAREHOLDER_STREET_NUMBER,
    INTERMEDIARY_SHAREHOLDER_VOTING_SHARE,
    INTERMEDIARY_SHAREHOLDER_ZIP_CODE,
  ],
  [SECTION_BANK_DETAILS]: [
    COMPANY_SELLER_BANK_ACCOUNT,
    SELLER_BANK_ACCOUNT_BANK_CODE,
    SELLER_BANK_ACCOUNT_ACCOUNT_NUMBER,
    SELLER_BANK_ACCOUNT_ACCOUNT_HOLDER,
    SELLER_BANK_ACCOUNT_TRANSFER_TYPE,
    SELLER_BANK_ACCOUNT_CURRENCIES,
    COMPANY_BANK_STATEMENTS,
  ],
  [SECTION_DIRECT_DEBIT_ACCOUNT_DETAILS]: [
    COMPANY_DIRECT_DEBIT_BANK_DETAILS,
    DIRECT_DEBIT_ACCOUNT_ACCOUNT_HOLDER,
    DIRECT_DEBIT_ACCOUNT_ACCOUNT_NUMBER,
    DIRECT_DEBIT_ACCOUNT_BANK_CODE,
    DIRECT_DEBIT_ACCOUNT_BANK_NAME,
    DIRECT_DEBIT_ACCOUNT_CITY,
    DIRECT_DEBIT_ACCOUNT_COUNTRY_CODE,
    DIRECT_DEBIT_ACCOUNT_STATE,
    DIRECT_DEBIT_ACCOUNT_STREET_NAME,
    DIRECT_DEBIT_ACCOUNT_STREET_NUMBER,
    DIRECT_DEBIT_ACCOUNT_ZIP_CODE,
  ],
  // COMPANY DOCUMENTS
  [SECTION_COMPANY_DOCUMENTS_LIST]: [
    COMPANY_ORGANIZATIONAL_CHART,
    COMPANY_CERTIFICATE_OF_INCORPORATION,
    COMPANY_MEMORANDUM_OF_ASSOCIATION,
    COMPANY_ARTICLES_OF_ASSOCIATION,
    COMPANY_CERTIFICATE_OF_REGISTRATION,
    COMPANY_TRADE_REGISTER_EXTRACT,
    COMPANY_SHARE_HOLDER_LIST,
    COMPANY_BOARD_RESOLUTION,
  ],
  [SECTION_OTHER_DOCUMENTS]: [
    COMPANY_CREDIT_FACILITIES,
    COMPANY_GROUP_BWA_1,
    COMPANY_GROUP_BWA_0,
    COMPANY_COMPANY_BWA_1,
    COMPANY_COMPANY_BWA_0,
    COMPANY_SUSA,
  ],
  ...DOCUMENTS_SUB_CATEGORIES_TO_INPUT_FIELDS,
}

export const DOCUMENT_SUBSECTION_CONFIG = {
  [SECTION_COMPANY_DOCUMENTS_LIST]: [
    SECTION_ORGANIZATIONAL_CHART,
    SECTION_CERTIFICATE_OF_INCORPORATION,
    SECTION_ASSOCIATION_DOCUMENTS,
    SECTION_COMPANY_PAN_CARD,
    SECTION_COMPANY_UTILITY_BILL,
    SECTION_PARTNERSHIP_DEED,
    SECTION_CERTIFICATE_OF_REGISTRATION,
    SECTION_BUSINESS_LICENSE,
    SECTION_TRADE_REGISTER_EXTRACT,
    SECTION_ANNUAL_RETURN_FILE,
    SECTION_SHARE_HOLDER_LIST,
    SECTION_TAX_NUMBER_CERTIFICATE,
    SECTION_BOARD_RESOLUTION,
    SECTION_DIRECTOR_LIST,
    SECTION_CHAMBER_OF_COMMERCE_CERTIFICATE,
    SECTION_EXTENDED_DUE_DILIGENCE,
  ],
  [SECTION_YEARLY_CLOSING_COMPANY]: [SECTION_YEARLY_CLOSING_COMPANY],
  [SECTION_YEARLY_CLOSING_GROUP]: [SECTION_YEARLY_CLOSING_GROUP],
  [SECTION_OTHER_DOCUMENTS]: [
    SECTION_CREDIT_FACILITIES,
    SECTION_BWA_GROUP_DOCUMENTS,
    SECTION_BWA_COMPANY_DOCUMENTS,
    SECTION_SUSA,
  ],
}

export const COMPANY_DOCUMENTS_SUBSECTIONS_INPUT_FIELD_MAP = {
  [SECTION_ORGANIZATIONAL_CHART]: [COMPANY_ORGANIZATIONAL_CHART],
  [SECTION_SHARE_HOLDER_LIST]: [COMPANY_SHARE_HOLDER_LIST],
  [SECTION_TAX_NUMBER_CERTIFICATE]: [COMPANY_TAX_NUMBER_CERTIFICATE],
  [SECTION_BOARD_RESOLUTION]: [COMPANY_BOARD_RESOLUTION],
  [SECTION_DIRECTOR_LIST]: [COMPANY_DIRECTOR_LIST],
  [SECTION_CHAMBER_OF_COMMERCE_CERTIFICATE]: [COMPANY_CHAMBER_OF_COMMERCE_CERTIFICATE],
  [SECTION_EXTENDED_DUE_DILIGENCE]: [COMPANY_EXTENDED_DUE_DILIGENCE],
  [SECTION_CERTIFICATE_OF_INCORPORATION]: [COMPANY_CERTIFICATE_OF_INCORPORATION],
  [SECTION_CERTIFICATE_OF_REGISTRATION]: [COMPANY_CERTIFICATE_OF_REGISTRATION],
  [SECTION_ASSOCIATION_DOCUMENTS]: [
    COMPANY_MEMORANDUM_OF_ASSOCIATION,
    COMPANY_ARTICLES_OF_ASSOCIATION,
  ],
  [SECTION_COMPANY_PAN_CARD]: [COMPANY_PAN_CARD],
  [SECTION_COMPANY_UTILITY_BILL]: [COMPANY_UTILITY_BILL],
  [SECTION_PARTNERSHIP_DEED]: [COMPANY_PARTNERSHIP_DEED],
  [SECTION_BUSINESS_LICENSE]: [COMPANY_BUSINESS_LICENSE],
  [SECTION_TRADE_REGISTER_EXTRACT]: [COMPANY_TRADE_REGISTER_EXTRACT],
  [SECTION_ANNUAL_RETURN_FILE]: [COMPANY_ANNUAL_TRADE_FILE],
}

export const COMPANY_FINANCIAL_DOCUMENTS_SUBSECTIONS_INPUT_FIELD_MAP = {
  [SECTION_BWA_GROUP_DOCUMENTS]: [COMPANY_GROUP_BWA_1, COMPANY_GROUP_BWA_0],
  [SECTION_BWA_COMPANY_DOCUMENTS]: [COMPANY_COMPANY_BWA_1, COMPANY_COMPANY_BWA_0],
  [SECTION_CREDIT_FACILITIES]: [COMPANY_CREDIT_FACILITIES],
  [SECTION_SUSA]: [COMPANY_SUSA],
  [SECTION_YEARLY_CLOSING_GROUP]: [
    GROUP_COMPANY_FINANCIAL_DOCUMENT,
    GROUP_COMPANY_INTERIM_FINANCIALS,
  ],
  [SECTION_YEARLY_CLOSING_COMPANY]: [
    COMPANY_FINANCIAL_DOCUMENTS,
    COMPANY_INTERIM_FINANCIAL_DOCUMENT,
  ],
}
